import type { Pattern } from '../types';

/** Compases visibles en pantalla de reproducción (ritmos). */
export const MEASURES_VISIBLE = 4;

/** Cuántos compases avanza la ventana deslizante. */
export const MEASURES_SHIFT = 2;

/** Boom Patrones: solo 2 compases visibles en el lienzo. */
export const MELODY_MEASURES_VISIBLE = 2;

/** Boom Patrones: avance de página al añadir compases. */
export const MELODY_MEASURES_SHIFT = 2;

export function slidingWindowStart(
  activeMeasureIndex: number | null,
  measureCount: number,
  visible = MEASURES_VISIBLE,
  shift = MEASURES_SHIFT,
): number {
  if (measureCount <= visible) return 0;
  if (activeMeasureIndex === null) return 0;
  const page = Math.floor(activeMeasureIndex / shift);
  const maxStart = Math.max(0, measureCount - visible);
  return Math.min(page * shift, maxStart);
}

export function visibleSlidingMeasures(
  activeMeasureIndex: number | null,
  measureCount: number,
  visible = MEASURES_VISIBLE,
  shift = MEASURES_SHIFT,
): number[] {
  const start = slidingWindowStart(activeMeasureIndex, measureCount, visible, shift);
  return Array.from({ length: visible }, (_, i) => start + i).filter(
    (i) => i < measureCount,
  );
}

export function totalSlidingPages(
  measureCount: number,
  visible = MEASURES_VISIBLE,
  shift = MEASURES_SHIFT,
): number {
  if (measureCount <= visible) return 1;
  const maxStart = measureCount - visible;
  return Math.floor(maxStart / shift) + 1;
}

export function pageForWindowStart(windowStart: number, shift = MEASURES_SHIFT): number {
  return Math.floor(windowStart / shift);
}

/** @deprecated Usar MEASURES_SHIFT */
export const MEASURES_PER_PAGE = MEASURES_SHIFT;

export function totalPages(measureCount: number): number {
  return totalSlidingPages(measureCount);
}

export function pageForMeasure(measureIndex: number): number {
  return Math.floor(measureIndex / MEASURES_SHIFT);
}

export function measureIndexForGlobalCell(
  globalIndex: number,
  pattern: Pattern,
): number {
  let g = 0;
  for (let m = 0; m < pattern.measures.length; m++) {
    let count = 0;
    for (const slot of pattern.measures[m].slots) {
      if (slot.active) count += slot.cells.length;
    }
    if (globalIndex < g + count) return m;
    g += count;
  }
  return Math.max(0, pattern.measures.length - 1);
}

export function allMeasureIndices(measureCount: number): number[] {
  return Array.from({ length: measureCount }, (_, i) => i);
}

/** @deprecated */
export function visibleMeasureRange(page: number, measureCount: number): number[] {
  const start = page * MEASURES_SHIFT;
  return Array.from({ length: MEASURES_VISIBLE }, (_, i) => start + i).filter(
    (i) => i < measureCount,
  );
}
